module.exports = __webpack_public_path__ + "static/img/y-1.0d5647ec.png";